import styled from 'styled-components/macro';
import { space, typography } from 'styled-system';
import { Props } from './simple-input';

export const StyledInput = styled.input<Props>`
  background-color: #ffffff;
  padding: 12px;
  font-size: 14px;
  border-radius: 8px;
  border: 1px solid ${(props) => (props.error ? '#FC8181' : '#D8DEEB')};
  box-shadow: ${(props) => (props.error ? '0 0 0 4px #FEE3E3' : 'none')};
  color: #071f3b;
  //color: #a8b3c1;
  width: -webkit-fill-available;
  width: -moz-fill-available;
  transition-duration: 0.2s;
  ${space};
  ${typography};

  &:hover {
    border-color: #9da6b4;
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
`;
